// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","355":"1fd05948","453":"03346f77","455":"1cda369a","977":"4b3215a8"}[chunkId] + ".chunk.js";
};